<template>
  <b-card v-if="application" class="mt-3" body-class="pb-0">
    <b-row class="pb-3 border-bottom">
      <b-col class="block-title">Apply Now</b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4" class="pt-3">
        <b-form-group label="First Name">
          <b-form-input :value="user.firstName" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" class="pt-3">
        <b-form-group label="Last Name">
          <b-form-input :value="user.lastName" disabled/>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" class="pt-3">
        <b-form-group label="Email Address">
          <b-form-input :value="user.emailAddress" disabled/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Message">
          <b-textarea placeholder="Type your message here..." v-model="application.message" rows="4" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="CV" label-for="formCV">
          <div class="dropzone border border-secondary-a5 py-0" id="formCV" ref="fileUploadArea">
            <div id="dropzone-message" style="display: none">
              <span class="dropzone-title">Click here to select your CV</span>
              <br/><span class="dropzone-info">Or drag-n-drop files here</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-checkbox id="termsAgreed" required v-model="application.termsAgreed" :class="{ 'is-invalid': isValid.termsAgreed }">
            I have read and understood the <a href="/static/documents/Real+Links+Terms+%26+Conditions.pdf">terms &amp; conditions</a> and <a href="https://www.reallinks.io/privacy-policy/">privacy policy</a>.
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pb-3">
      <b-col>
        <b-button
          variant="primary"
          class="float-right"
          @click="applySubmit()"
          :disabled="!applicationValid"
        >Send Application</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Dropzone from 'dropzone';
import gql from 'graphql-tag';
import { mapRoot } from '@src/mixins/root';

Dropzone.autoDiscover = false;

const CreateAssetMutation = gql`
  mutation createAsset($create: CreateAssetInput!) {
    createAsset(create: $create) {
      asset {
        id
        status
      }
      token
      upload {
        url
        headers
        body
      }
    }
  }
`;

const UploadedAssetMutation = gql`
  mutation createAsset($token: String!) {
    uploadedAsset(token: $token) {
      id
      status
    }
  }
`;

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    err: null,
    application: null,
  }),
  mounted() {
    const self = this;
    console.log('VALUE FROM MOUNTED: ', this.value);
    this.application = this.value;
    setTimeout(() => {
      const dropzone = new Dropzone(self.$refs.fileUploadArea, {
        method: 'POST',
        url: '/',
        headers: {},
        maxFiles: 1,
        parallelUploads: 1,
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true,
        dictDefaultMessage: self.$refs.fileUploadArea.querySelector('#dropzone-message').innerHTML,
        acceptedFiles: 'text/*,application/*',
        accept(file, done) {
          self.createAsset(file).then(() => {
            const { createAsset: { upload } } = file;
            dropzone.options.url = upload.url;
            dropzone.options.headers = upload.headers || {};
            done();
            // setTimeout(() => dropzone.processFile(file));
          }).catch(err => {
            self.$log.error(err);
            self.$notifyErr(err, { prepend: 'Failed to upload CV:' });
            done('Failed to upload CV', err);
          });
        },
        sending(file, xhr, formData) {
          const { createAsset: { upload } } = file;
          Object.keys(upload.body || {}).forEach(key => formData.append(key, upload.body[key]));
        },
        success(file) {
          dropzone.options.url = '/';
          dropzone.options.headers = {};

          self.uploadedAsset(file)
            .then(() => self.$log.info('Successfully uploaded the asset!', file))
            .catch(err => {
              self.$log.error(err);
              self.$notifyErr(err, { prepend: 'Failed to upload CV:' });
              dropzone.emit('error', file, 'Failed to mark asset as uploaded');
            });
        },
      });
    }, 1000);
  },
  computed: {
    ...mapRoot([ 'user' ]),
    isValid() {
      const isValid = {};

      if (this.application.hasOwnProperty('termsAgreed')) {
        isValid.termsAgreed = this.application.termsAgreed === true;
      } else {
        isValid.termsAgreed = null;
      }

      return isValid;
    },
    applicationValid() {
      const { isValid } = this;
      return Object.keys(isValid).reduce((out, key) => out && isValid[key], true);
    },
  },
  methods: {
    async createAsset(file) {
      this.$log.debug('createAsset', file);

      const { data } = await this.$apollo.mutate({
        mutation: CreateAssetMutation,
        variables: {
          create: {
            type: 'DOCUMENT',
            fileName: file.name,
            fileMime: file.type,
            fileSize: file.size,
            fileSha1: 'fkvjndfvkjndfv',
          },
        },
      });

      this.$log.debug('createAsset', data.createAsset.asset);
      this.$log.debug('createAsset', data.createAsset.upload);

      file.createAsset = data.createAsset;
    },
    async uploadedAsset(file) {
      const { token } = file.createAsset;
      const { data } = await this.$apollo.mutate({
        mutation: UploadedAssetMutation,
        variables: { token },
      });
      this.$log.debug('uploadedAsset', 'Marking asset as DONE');
      if (data && data.uploadedAsset && data.uploadedAsset.id) {
        this.application.CV = { id: data.uploadedAsset.id };
      }
    },
    async applySubmit() {
      if (this.applicationValid) {
        this.$emit('input', this.application);
      }
    },
  },
};
</script>
<style lang="scss">
.page .internal-job-show {
  .dropzone {
    padding: 0;
    width: 100%;

    .dz-message {
      margin: 1em 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/InternalJobApplicationForm.vue